export const initialValue = {
    dashboards: [],
    loading: false,
};

export default function dashboardReducer(state = initialValue, action) {
    switch (action.type) {
        case "FETCH_DASHBOARDS_PENDING":
            return {...state, loading: true};
        case "FETCH_DASHBOARDS_FULFILLED":
            return {...state, dashboards: action.payload, loading: false};
        case "FETCH_DASHBOARDS_REJECTED":
            return {...state, loading: false};
        case "UPDATE_DASHBOARD": {
            const currentDashboards = state.dashboards.slice();
            const index = currentDashboards.findIndex(
                (item) => item.SetID === action.payload.SetID
            );
            if (index >= 0) {
                currentDashboards[index] = action.payload;
            } else {
                currentDashboards.push(action.payload);
            }
            return {...state, dashboards: currentDashboards};
        }
        case "DELETE_DASHBOARD": {
            const currentDashboards = state.dashboards.filter(
                (item) => item.SetID !== action.payload
            );
            return {...state, dashboards: currentDashboards};
        }
        case "CHANGE_FARM":
        case "USER_LOGOUT_FULFILLED": {
            return initialValue;
        }
        default:
            return state;
    }
}
